<!--============================
=            APPTOP            =
=============================-->
<template>
  <div
    class="appTop flex justify-between align-center"
    :style="{'background-image': 'url('+appConfig.bg+')'}"
    :class="{'elevation-2':appConfig.scroll>60,'appTop--small':appConfig.small}"
  >
    <div class="appTop__leftIcons hidden-sm-and-down">
      <transition name="fade2" mode="out-in">
        <h1 v-if="appConfig.scroll>60" class="appTop__title md1">{{appConfig.title2.name}}</h1>
      </transition>
    </div>
    <div class="appTop__rightIcons mr-3">
      <!-- <span class="mr-2 mb-1">{{ $t("BatteryPackList.Columns.SerialNo") }} :</span>
      <v-select
        :items="serialItems"
        v-model="selectedSerialNo"
      ></v-select>-->
      <div>
        <img :src="languageImageUrl">
      </div>
      <v-btn @click="toggleFull()" icon>
        <v-icon color="white">fullscreen</v-icon>
      </v-btn>
      <!-- <v-menu bottom left>
        <v-btn slot="activator" dark icon>
          <v-icon color="white">notifications</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile v-for="(item, i) in menuitems" :key="i">
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>-->
    </div>
  </div>
</template>

<script>
import mediator from "../common/mediator.vue";

export default {
  name: "appTop",
  mixins: [mediator],
  mounted() {
    this.setServerLanguage();

    this.subscriber("GetSelectSerial", this.getSelectSerial, this);
    this.subscriber("SetSelectSerial", this.setSelectSerial, this);
  },
  methods: {
    toggleFull() {
      let el = document.documentElement;
      let rfs;

      if (!this.isFullScreen) {
        if (el.webkitRequestFullScreen) {
          el.webkitRequestFullScreen();
        } else if (el.mozRequestFullScreen) {
          el.mozRequestFullScreen();
        } else {
          el.requestFullScreen();
        }

        this.isFullScreen = true;
      } else {
        if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else {
          document.exitFullscreen();
        }

        this.isFullScreen = false;
      }

      if (el.fullscreenEnabled) {
        el.webkitCancelFullScreen();
      }
      //rfs.call(el);
    },
    getSerialList() {
      let self = this;

      self.axios
        .get(`${self.$root.url}/Common/SerialNoByUser`, {
          headers: {
            Authorization: `Bearer ${this.$root.token}`
          },
          params: {
            assign: this.$root.assign,
            type: this.$root.type
          }
        })
        .then(response => {
          self.serialItems = response.data;
          self.selectedSerialNo = self.serialItems[0];
        })
        .catch(error => {
          self.error = true;
          self.result = "Error";
          self.showResult = true;
        });
    },
    getSelectSerial() {
      return this.selectedSerialNo;
    },
    setSelectSerial(serialNo) {
      this.selectedSerialNo = serialNo;
    },
    setServerLanguage() {
      const language = this.publisher("GetServerLanguage", []);
      switch(language) {
        case 'ja-JP':
          this.languageImageUrl = 'static/images/jp.png';
          break;
        case 'zh-CN':
          this.languageImageUrl = 'static/images/ch.png';
          break;
      }
    }
  },
  data() {
    const $t = this.$t.bind(this);

    return {
      selectedSerialNo: "",
      serialItems: [],
      menuitems: [{ title: "Messages" }, { title: "logout" }],
      isFullScreen: false,
      currentServerLang: '',
      languageImageUrl: '',
    };
  }
};
</script>

<style lang="css" scoped>
.v-select__slot .v-label {
  background: white !important;
  color: white !important;
}

.fade2-enter-active,
.fade2-leave-active {
  transition: margin-top 150ms;
}

.fade2-enter,
  .fade2-leave-to

  /* .fade-leave-active below version 2.1.8 */
 {
  margin-top: 320px;
}

.appTop {
  min-height: 50px;
  overflow: hidden;
  width: calc(100vw);
  background-size: cover;
  z-index: 88;
  max-height: 50px;
  display: flex;
  position: fixed;
  background-position-x: -220px;
  padding: 10px;
  padding-left: 20px;
  align-items: center;
  margin-left: 220px;
  position: fixed;
  top: 0px;
  color: white;
  left: 0px;
}

.appTop__title {
  color: #fff;
  margin-left: 10px;
  height: 48px;
  vertical-align: middle;
  line-height: 50px;
  font-weight: 700;
  text-transform: capitalize;
}

.appTop--small {
  margin-left: 50px;
  padding: 10px;
  background-position-x: -50px;
}

.appTop__leftIcons {
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: max-content;
}

.appTop__leftIcons .v-btn,
.appTop__rightIcons .v-btn {
  z-index: 999;
}

.appTop__rightIcons {
  right: 0px;
  display: flex !important;
  align-items: center;
  z-index: 9999;
  position: fixed;
}

@media (max-width: 950px) {
  .appTop {
    min-height: 50px;
    overflow: hidden;
    width: calc(100vw);
    background-size: inherit;
    z-index: 88;
    max-height: 50px;
    display: flex;
    position: fixed;
    background-position-x: 0;
    padding: 10px;
    padding-left: 20px;
    align-items: center;
    margin-left: 0;
    position: fixed;
    top: 0px;
    color: white;
    left: 0px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/layout/AppTop.vue